import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import ItAssetDashboardLayer from '../components/ItAssetDashboardLayer'

const ItAssetDashboardPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title='IT Asset Dashboard' />
      <ItAssetDashboardLayer />
    </MasterLayout>
  )
}

export default ItAssetDashboardPage

